import React, { useState, useEffect } from 'react';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { auth, db } from '../firebase'; // adjust path as needed
import './UserAccountPage.css';
import { useNavigate } from 'react-router-dom';

const UserAccountPage = () => {
  const [activeTab, setActiveTab] = useState('account');
  const [userData, setUserData] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [isEditing, setIsEditing] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserInfo = async () => {
      const user = auth.currentUser;
      if (user) {
        const userRef = doc(db, 'users', user.phone);
        const docSnap = await getDoc(userRef);
        if (docSnap.exists()) {
          setUserData(docSnap.data());
          setEditedData(docSnap.data());
          setLoading(false);
        }
      }
    };
    fetchUserInfo();
  }, []);

  const handleEdit = (field) => {
    setIsEditing((prev) => ({ ...prev, [field]: true }));
  };

  const handleChange = (e, field) => {
    setEditedData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleCancel = () => {
    setEditedData(userData);
    setIsEditing({});
  };

  const handleSave = async () => {
    const user = auth.currentUser;
    if (user) {
      const userRef = doc(db, 'users', user.uid);
      await updateDoc(userRef, editedData);
      setUserData(editedData);
      setIsEditing({});
    }
  };

  if (loading) return <p>Loading account details...</p>;

  return (
    <div className="user-account-container">
      <div className="tabs">
        <button className="back-to-dashboard" onClick={() => navigate("/dashboard")}>Back to Dashboard</button>
        <button className={activeTab === 'account' ? 'active' : ''} onClick={() => setActiveTab('account')}>Account</button><div className="tabagap"></div>
        <button className={activeTab === 'billing' ? 'active' : ''} onClick={() => setActiveTab('billing')}>Billing</button>
      </div>

      <div className="tab-content">
        {activeTab === 'account' && (
          <div className="account-tab">
            {['name', 'email', 'phone'].map((field) => (
              <div key={field} className="field-row">
                <label>{field.charAt(0).toUpperCase() + field.slice(1)}</label>
                {isEditing[field] ? (
                  <input
                    type="text"
                    value={editedData[field] || ''}
                    onChange={(e) => handleChange(e, field)}
                  />
                ) : (
                  <span>{userData[field] || '—'}</span>
                )}
                <span className="edit-icon" onClick={() => handleEdit(field)}>✏️</span>
              </div>
            ))}
          </div>
        )}

        {activeTab === 'billing' && (
          <div className="billing-tab">
  <h3>Billing Address</h3>

  {['country', 'state', 'city', 'zip', 'street1', 'street2'].map((field) => (
    <div key={field} className="field-row">
      <label>
        {field === 'street1'
          ? 'Street Address 1'
          : field === 'street2'
          ? 'Street Address 2'
          : field.charAt(0).toUpperCase() + field.slice(1)}
      </label>
      {isEditing[field] ? (
        <input
          type="text"
          value={editedData[field] || ''}
          onChange={(e) => handleChange(e, field)}
        />
      ) : (
        <span className={userData[field] ? '' : 'placeholder'}>
          {userData[field] || '—'}
        </span>
      )}
      <span className="edit-icon" onClick={() => handleEdit(field)}>✏️</span>
    </div>
  ))}

  <div className="field-row">
    <label>Plan</label>
    {userData.plan === 'trial' ? (
      <span className="trial-label">Trial</span>
    ) : isEditing.plan ? (
      <input
        type="text"
        value={editedData.plan || ''}
        onChange={(e) => handleChange(e, 'plan')}
      />
    ) : (
      <span>{userData.plan || '—'}</span>
    )}
    <span className="edit-icon" onClick={() => handleEdit('plan')}>✏️</span>
  </div>

  <div className="cancel-sub">
    <button className="cancel-sub-btn">Cancel Subscription</button>
  </div>
</div>

        )}
      </div>

      <div className="bottom-actions">
        <button className="cancel-btn" onClick={handleCancel}>Cancel</button>
        <button className="save-btn" onClick={handleSave}>Save</button>
      </div>
    </div>
  );
};

export default UserAccountPage;
